import { createSegmentActionsPlugin } from '@amplitude/segment-session-replay-plugin';
import { useRef } from 'react';
import { getAnalyticsBrowserInstance } from 'services/analytics/segment/segment';
import { useStatsig } from 'shared/hooks/statsig/useStatsig';
import { FeatureFlagKey } from 'shared/providers/statsig/StatsigProvider.d';
import getEnvironmentVar from 'shared/utils/getEnvironmentVar';

export const useAmplitudeReplays = () => {
  const { isFeatureEnabled } = useStatsig();
  const isReplayInitialized = useRef(false);

  const initializeAmplitudeReplay = () => {
    if (
      !isReplayInitialized.current &&
      isFeatureEnabled(FeatureFlagKey.AMPLITUDE_REPLAY) &&
      !__DEV__
    ) {
      try {
        const AMPLITUDE_API_KEY = getEnvironmentVar('EXPO_AMPLITUDE_API_KEY');
        const analyticsBrowser = getAnalyticsBrowserInstance();

        void createSegmentActionsPlugin({
          segmentInstance: analyticsBrowser,
          amplitudeApiKey: AMPLITUDE_API_KEY,
          sessionReplayOptions: {
            sampleRate: 0.1,
          },
        });

        isReplayInitialized.current = true;

        console.log('Session replay plugin successfully initialized');
      } catch (error) {
        console.error('Failed to initialize Amplitude Session Replay:', error);
      }
    }
  };

  return initializeAmplitudeReplay;
};
